
import { AnyAction } from 'redux';
import { IThemesState, THEMES_STATE } from './themes.model';
import { ThemesActionService } from './themes.action';

export function themesReducer(state: IThemesState =  THEMES_STATE, action: AnyAction): IThemesState {

    switch (action.type) {

        case ThemesActionService.THEMES_LIST:
            return {
              ...state,
                list: action.payload
            };

        case ThemesActionService.SET_THEMES_CURRENT:
            return {
              ...state,
                current: action.payload
            };

        case ThemesActionService.ADD_OR_UPDATE_THEMES:
          if (state.list.length !== 0) {
            const themeIdx = state.list.findIndex(({id}) => id === action.payload.id);
            let updatedList = [];
            if (themeIdx > -1) {
              updatedList = state.list.map((elem) => {
                if (action.payload.id === elem.id) {
                  return action.payload;
                } else {
                  return elem;
                }
              });
            } else {
              updatedList = [...state.list];
            }
            return {
              ...state,
              list: updatedList
            };
          } else {
            return { ...state };
          }

        case ThemesActionService.DELETE_THEMES:
          const list = state.list.filter(theme => theme.id !== action.payload);
          return {
            ...state,
            list
          };

    }

    return state;
}
